const so71reasoncodelist = [
{reasoncode:  6,subreasoncode:  188 , message:"DO NOT DEVAN – EXAM"},
{reasoncode: 11,subreasoncode:  100 , message:"DETAINED"},
{reasoncode: 11,subreasoncode:  101 , message:"CANCEL DETENTION"},
{reasoncode: 11,subreasoncode:  104 , message:"PGA INSPECTION NEEDED"},
{reasoncode: 12,subreasoncode:  105 , message:"EXAM"},
{reasoncode: 12,subreasoncode:  106 , message:"EXAM NOTIFY"},
{reasoncode: 12,subreasoncode:  189 , message:"TRANSFER TO APHIS CUSTODY"},
{reasoncode: 12,subreasoncode:  190 , message:"TRANSFER TO PGA FACILITY"},
{reasoncode: 12,subreasoncode:  193 , message:"PGA DOCUMENT AVAILABLE FOR TRADE FROM PGA"},
{reasoncode: 14,subreasoncode:  107 , message:"FOREIGN ULTIMATE CONSIGNEE"},
{reasoncode: 14,subreasoncode:  108 , message:"MISSING REGISTRATION"},
{reasoncode: 14,subreasoncode:  109 , message:"REGISTRATION NOT ON FILE"},
{reasoncode: 14,subreasoncode:  110 , message:"MISMATCH IN REGISTRATION"},
{reasoncode: 14,subreasoncode:  111 , message:"CANCELLED MANUFACTURER FACILITY REGISTRATION"},
{reasoncode: 14,subreasoncode:  112 , message:"FACILITY REGISTRATION INVALIDATED BY FDA DATA"},
{reasoncode: 14,subreasoncode:  113 , message:"INVALID QUANTITY FORMAT"},
{reasoncode: 14,subreasoncode:  114 , message:"INVALID ID FOR MANUFACTURER"},
{reasoncode: 14,subreasoncode:  115 , message:"INVALID ID FOR SHIPPER"},
{reasoncode: 14,subreasoncode:  116 , message:"INVALID ID FOR IMPORTER"},
{reasoncode: 14,subreasoncode:  117 , message:"INVALID ID FOR ULTIMATE CONSIGNEE"},
{reasoncode: 14,subreasoncode:  118 , message:"INVALID STATE/ZIP FOR US MANUFATURER"},
{reasoncode: 14,subreasoncode:  119 , message:"INVALID COUNTRY OF PRODUCTION"},
{reasoncode: 14,subreasoncode:  120 , message:"INVALID COUNTRY OF SHIPPING"},
{reasoncode: 14,subreasoncode:  122 , message:"INVALID EXEMPTION (FME) QUALIFIER"},
{reasoncode: 14,subreasoncode:  123 , message:"INVALID PNC NUMBER"},
{reasoncode: 14,subreasoncode:  124 , message:"EXPIRED PNC NUMBER"},
{reasoncode: 14,subreasoncode:  125 , message:"CANCELLED PNC NUMBER"},
{reasoncode: 14,subreasoncode:  126 , message:"INVALID FILER"},
{reasoncode: 14,subreasoncode:  127 , message:"INVALID OWNER ENTITY ID"},
{reasoncode: 14,subreasoncode:  128 , message:"INVALID SUBMITTER ENTITY ID"},
{reasoncode: 14,subreasoncode:  129 , message:"INVALID TRANSMITTER ENTITY ID"},
{reasoncode: 14,subreasoncode:  130 , message:"INVALID DELIVER TO PARTY ENTITY ID"},
{reasoncode: 14,subreasoncode:  149 , message:"FDA PRODUCT CODE MISMATCH TO GROWER/CONSOLITATOR/MANUFACTURER ROLE CODE"},
{reasoncode: 14,subreasoncode:  131 , message:"MISSING BILL OF LADING OR AIR WAY BILL"},
{reasoncode: 14,subreasoncode:  151 , message:"MISSING DATA"},
{reasoncode: 14,subreasoncode:  152 , message:"INVALID CANADIAN PROVINCE"},
{reasoncode: 14,subreasoncode:  153 , message:"INVALID PRODUCT CODE"},
{reasoncode: 14,subreasoncode:  154 , message:"MISSING OR INVALID DATE"},
{reasoncode: 14,subreasoncode:  155 , message:"MISSING, INVALID, OR EXPIRED FWS IMPORT/EXPORT LICENSE NUMBER"},
{reasoncode: 14,subreasoncode:  156 , message:"INVALID FWS PORT"},
{reasoncode: 14,subreasoncode:  157 , message:"INACCURATE FWS INTENDED USE DESCRIPTION"},
{reasoncode: 14,subreasoncode:  158 , message:"MISSING CARRIER NAME"},
{reasoncode: 14,subreasoncode:  159 , message:"MISSING OR INVALID MODE OF TRANSPORTATION CODE"},
{reasoncode: 14,subreasoncode:  160 , message:"MISSING OR INACCURATE BONDED LOCATION FOR INSPECTION"},
{reasoncode: 14,subreasoncode:  161 , message:"MISSING OR INVALID NUMBER OF CARTONS CONTAINING WILDLIFE"},
{reasoncode: 14,subreasoncode:  162 , message:"MISSING OR INVALID FWS US IMPORTER"},
{reasoncode: 14,subreasoncode:  163 , message:"MISSING OR INVALID FWS FOREIGN EXPORTER"},
{reasoncode: 14,subreasoncode:  164 , message:"MISSING OR INVALID SHIPPING AGENT"},
{reasoncode: 14,subreasoncode:  165 , message:"MISSING OR INVALID FREIGHT FORWARDER"},
{reasoncode: 14,subreasoncode:  166 , message:"MISSING OR INVALID SCIENTIFIC GENUS NAME"},
{reasoncode: 14,subreasoncode:  167 , message:"MISSING OR INVALID SCIENTIFIC SPECIES NAME"},
{reasoncode: 14,subreasoncode:  168 , message:"MISSING OR INVALID SCIENTIFIC SUBSPECIES NAME"},
{reasoncode: 14,subreasoncode:  169 , message:"MISSING OR INVALID COMMON NAME"},
{reasoncode: 14,subreasoncode:  170 , message:"MISSING OR INVALID FOREIGN CITES PERMIT NUMBER"},
{reasoncode: 14,subreasoncode:  171 , message:"MISSING OR INVALID U.S. CITES PERMIT NUMBER"},
{reasoncode: 14,subreasoncode:  172 , message:"MISSING OR INVALID MARKINGS ON CARTONS CONTAINING WILDLIFE"},
{reasoncode: 14,subreasoncode:  173 , message:"MISSING OR INVALID FWS DESCRIPTION CODE"},
{reasoncode: 14,subreasoncode:  174 , message:"MISSING OR INVALID PGA COMMODITY QUALIFIER CODE (FWS SOURCE CODE)"},
{reasoncode: 14,subreasoncode:  175 , message:"MISSING OR INVALID FWS QUANTITY OR UNIT OF MEASURE"},
{reasoncode: 14,subreasoncode:  176 , message:"FWS CORPORATE ACCOUNT PAYMENT IS OVERDUE"},
{reasoncode: 14,subreasoncode:  177 , message:"MISSING OR INVALID FWS VALUE"},
{reasoncode: 14,subreasoncode:  178 , message:"INVALID FWS COUNTRY OF SPECIES ORIGIN"},
{reasoncode: 14,subreasoncode:  179 , message:"MISSING OR INVALID VENOMOUS WILDLIFE FLAG"},
{reasoncode: 14,subreasoncode:  183 , message:"INVALID UNITS OF MEASURE FOR COMMODITY"},
{reasoncode: 14,subreasoncode:  195 , message:"ENTRY TYPE NOT ALLOWED FOR PGA"},
{reasoncode: 14,subreasoncode:  196 , message:"PN DATA NOT ALLOWED FOR ENTRY TYPE"},
{reasoncode: 14,subreasoncode:  197 , message:"INVALID FORMAT FOR MANDATORY EMAIL REQUIREMENT"},
{reasoncode: 21,subreasoncode:  100 , message:"DETAINED"},
{reasoncode: 21,subreasoncode:  101 , message:"CANCEL DETENTION"},
{reasoncode: 21,subreasoncode:  181 , message:"PENDING REVIEW BY COMPLIANCE STAFF"},
{reasoncode: 25,subreasoncode:  132 , message:"DOCUMENTATION NEEDED"},
{reasoncode: 25,subreasoncode:  187 , message:"SECOND AND FINAL REQUEST FOR INFORMATION"},
{reasoncode: 26,subreasoncode:  108 , message:"MISSING REGISTRATION"},
{reasoncode: 26,subreasoncode:  109 , message:"REGISTRATION NOT ON FILE"},
{reasoncode: 26,subreasoncode:  110 , message:"MISMATCH IN REGISTRATION"},
{reasoncode: 26,subreasoncode:  111 , message:"CANCELLED MANUFACTURER FACILITY REGISTRATION"},
{reasoncode: 26,subreasoncode:  112 , message:"MANUFACTURER FACILITY REGISTRATION INVALIDATED BY FDA"},
{reasoncode: 26,subreasoncode:  120 , message:"INVALID COUNTRY OF SHIPPING"},
{reasoncode: 26,subreasoncode:  122 , message:"INVALID EXEMPTION (FME) QUALIFIER"},
{reasoncode: 26,subreasoncode:  158 , message:"MISSING CARRIER NAME"},
{reasoncode: 28,subreasoncode:  186 , message:"HOLD PENDING ANALYSIS RESULTS OF SAMPLED LINE"},
{reasoncode: 37,subreasoncode:  198 , message:"MAY PROCEED RESCINDED – HOLD FOR FURTHER INFORMATION FROM PGA."},
{reasoncode: 37,subreasoncode:  199 , message:"RELEASE RESCINDED – HOLD FOR FURTHER INFORMATION FROM PGA"},
{reasoncode: 37,subreasoncode:  200 , message:"REFUSAL RESCINDED – PRODUCT STILL DETAINED"},
{reasoncode: 40,subreasoncode:  146 , message:"RE-EXPORT"},
{reasoncode: 40,subreasoncode:  147 , message:"DESTROY"},
{reasoncode: 40,subreasoncode:  100 , message:"DETAINED"},
{reasoncode: 40,subreasoncode:  101 , message:"CANCEL DETENTION"},
{reasoncode: 40,subreasoncode:  102 , message:"FULL REFUSE"},
{reasoncode: 40,subreasoncode:  103 , message:"PARTIAL RELEASE AND REFUSE"},
{reasoncode: 40,subreasoncode:  144 , message:"REFUSAL SATISFIED"},
{reasoncode: 40,subreasoncode:  180 , message:"DIVERT TO ACCEPTABLE USE"},
{reasoncode: 40,subreasoncode:  182 , message:"REFUSED-INFORM BEFORE EXPORT OR DESTRUCTION"},
{reasoncode: 40,subreasoncode:  184 , message:"PARTIAL REFUSAL-INFORM BEFORE EXPORT OR DESTRUCTION"},
{reasoncode: 40,subreasoncode:  185 , message:"PARTIAL REFUSAL-INFORM AFTER EXPORT OR DESTRUCTION"},
{reasoncode: 40,subreasoncode:  192 , message:"REFUSED-INFORM AFTER EXPORT OR DESTRUCTION"},
{reasoncode: 52,subreasoncode:  133 , message:"INACCURATE MANUFACTURER"},
{reasoncode: 52,subreasoncode:  134 , message:"INACCURATE ULTIMATE CONSIGNEE"},
{reasoncode: 52,subreasoncode:  135 , message:"INACCURATE SHIPPER"},
{reasoncode: 52,subreasoncode:  136 , message:"INACCURATE IMPORTER"},
{reasoncode: 52,subreasoncode:  137 , message:"INACURRATE FDA PRODUCT CODE"},
{reasoncode: 52,subreasoncode:  138 , message:"INACCURATE BILL OF LADING OR AIRWAY BILL"},
{reasoncode: 52,subreasoncode:  139 , message:"INACCURATE PRIOR NOTICE INFORMATION"},
{reasoncode: 52,subreasoncode:  191 , message:"UNTIMELY PRIOR NOTICE"},
{reasoncode: 95,subreasoncode:  194 , message:"DOCUMENTATION CAN BE FOUND IN THE PGA DOCUMENTS SECTION IN YOUR ACE PORTAL ACCOUNT"},
]



export default so71reasoncodelist;